import { render, staticRenderFns } from "./66byvideo.vue?vue&type=template&id=5fca8b3e&"
import script from "./66byvideo.vue?vue&type=script&lang=js&"
export * from "./66byvideo.vue?vue&type=script&lang=js&"
import style0 from "./66byvideo.vue?vue&type=style&index=0&id=5fca8b3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports